"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var QuestionFieldStore = /** @class */ (function () {
    function QuestionFieldStore(rootStore) {
        var _this = this;
        this.setSelectedQuestionField = function (questionField) {
            _this.selectedQuestionField = questionField;
        };
        this.rootStore = rootStore;
        this.selectedQuestionField = {
            key: '',
            text: '',
            value: ''
        };
        mobx_1.makeAutoObservable(this);
    }
    return QuestionFieldStore;
}());
exports.default = QuestionFieldStore;
//# sourceMappingURL=questionFieldStore.js.map